import React from 'react';
import { withLazyComponent } from './with-lazy-component';

const Component = React.lazy(() => import('../components/checkbox/checkbox-with-image'));

export default function (dependencies) {
  const { language } = dependencies;
  const html = (props) => {
    const LazyComponent = withLazyComponent(Component);
    return LazyComponent({ ...props, ...dependencies });
  };

  return {
    html,
    validators: [
      function (state) {
        if (state.value.length !== 0) {
          return false;
        } else {
          return language.error_radio_button;
        }
      },
    ],
  };
}
